import JSSM4 from 'jssm4';

class SM4Helper {
    constructor(key, iv = null) {
        if (key.length !== 16) {
            throw new Error(`密钥长度必须为16字节，当前长度：${key.length}`);
        }
        this.key = key;
        
        if (iv) {
            if (iv.length !== 16) {
                throw new Error(`IV长度必须为16字节，当前长度：${iv.length}`);
            }
            this.iv = iv;
            this.mode = 'CBC';
        } else {
            this.iv = null;
            this.mode = 'ECB';
        }
        
        this.sm4 = new JSSM4(this.key);
    }
    
    /**
     * 加密
     * @param {string} plainText - 明文字符串（支持中文）
     * @returns {string} 密文（Hex格式）
     */
    encrypt(plainText) {
        let base64Cipher;
        if (this.mode === 'CBC') {
            base64Cipher = this.sm4.encryptData_CBC(plainText, this.iv);
        } else {
            base64Cipher = this.sm4.encryptData_ECB(plainText);
        }
        
        // 转换为Hex格式（匹配后端）
        return this._base64ToHex(base64Cipher);
    }
    
    /**
     * 解密
     * @param {string} hexCiphertext - 密文（Hex格式）
     * @returns {string} 明文字符串
     */
    decrypt(hexCiphertext) {
        const base64Cipher = this._hexToBase64(hexCiphertext);
        
        let result;
        if (this.mode === 'CBC') {
            result = this.sm4.decryptData_CBC(base64Cipher, this.iv);
        } else {
            result = this.sm4.decryptData_ECB(base64Cipher);
        }
        
        return result;
    }
    
    /**
     * 加密（直接返回Base64格式）
     */
    encryptToBase64(plainText) {
        if (this.mode === 'CBC') {
            return this.sm4.encryptData_CBC(plainText, this.iv);
        } else {
            return this.sm4.encryptData_ECB(plainText);
        }
    }
    
    /**
     * 解密（从Base64格式）
     */
    decryptFromBase64(base64Ciphertext) {
        if (this.mode === 'CBC') {
            return this.sm4.decryptData_CBC(base64Ciphertext, this.iv);
        } else {
            return this.sm4.decryptData_ECB(base64Ciphertext);
        }
    }
    
    getMode() {
        return this.mode;
    }
    
    // ==================== 工具方法 ====================
    
    _base64ToHex(base64Str) {
        const binaryStr = atob(base64Str);
        let hex = '';
        for (let i = 0; i < binaryStr.length; i++) {
            const hexByte = binaryStr.charCodeAt(i).toString(16);
            hex += hexByte.length === 2 ? hexByte : '0' + hexByte;
        }
        return hex;
    }
    
    _hexToBase64(hexStr) {
        let binaryStr = '';
        for (let i = 0; i < hexStr.length; i += 2) {
            binaryStr += String.fromCharCode(parseInt(hexStr.substr(i, 2), 16));
        }
        return btoa(binaryStr);
    }
}

export { SM4Helper }
export default SM4Helper